var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talent-main"},[_c('talants-list-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }